import React, { useState } from "react";
import { Save, X } from "lucide-react";
import { shopApi } from "../../context/ShopAuthContext";
import { Button } from "../ui/button";
import { CoreField, CoreError, agentError } from "./common";

const empty = {first_name:"",last_name:"",company_name:"",email:"",phone:"",street:"",house_number:"",postal_code:"",city:"",country:""};
const fields = [
  ["first_name","Voornaam",true], ["last_name","Achternaam",true], ["company_name","Bedrijfsnaam",false],
  ["email","E-mailadres",true,"email"], ["phone","Telefoonnummer",true,"tel"], ["street","Straat",true],
  ["house_number","Huisnummer",true], ["postal_code","Postcode",true], ["city","Plaats",true], ["country","Land",true],
];
export const CustomerForm = ({ record, onSaved, onCancel }) => {
  const [values, setValues] = useState(record ? Object.fromEntries(Object.keys(empty).map(k => [k, k === "street" ? record.address || "" : record[k] || ""])) : empty);
  const [key] = useState(() => crypto.randomUUID());
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async e => {
    e.preventDefault(); if(busy) return; setBusy(true); setError("");
    try {
      const r = record ? await shopApi.patch(`/agent-access/core/customers/${record.id}`, {...values, expected_updated_at:record.updated_at})
        : await shopApi.post("/agent-access/core/customers", values, {headers:{"Idempotency-Key":key}});
      onSaved(r.data);
    } catch(e) { setError(agentError(e)); } finally { setBusy(false); }
  };
  return <form onSubmit={submit} className="core-form" data-testid="agent-customer-form">
    <header className="core-form-heading"><h2>{record ? "Klant bewerken" : "Nieuwe klant"}</h2><Button type="button" variant="ghost" onClick={onCancel} data-testid="agent-customer-form-close" aria-label="Formulier sluiten"><X size={18}/></Button></header>
    <CoreError error={error} id="agent-customer-form-error"/>
    <fieldset disabled={busy} className="core-field-grid">
      {fields.map(([name,label,required,type]) => <CoreField key={name} id={`agent-customer-${name}`} label={label} value={values[name]} required={required} type={type}
        maxLength={name === "email" ? 254 : 160} minLength={name === "phone" ? 4 : undefined} onChange={value => setValues(v => ({...v,[name]:value}))}/>)}
    </fieldset>
    <div className="core-actions"><Button type="submit" disabled={busy} data-testid="agent-customer-save"><Save size={16}/>{busy ? "Opslaan…" : "Klant opslaan"}</Button><Button type="button" variant="outline" disabled={busy} onClick={onCancel} data-testid="agent-customer-cancel">Annuleren</Button></div>
  </form>;
};